module.exports = __webpack_public_path__ + "static/media/009.a5084623.jpg";